import { get, writable } from 'svelte/store';
import { TraceabilityService } from '../../services/traceability.service';
export const loading = writable(false);
export const request = writable({ referenceType: "slaughter", referenceValue: "" });
export const response = writable();
export async function init() {
    request.set({ referenceType: "slaughter", referenceValue: "" });
    response.set(null);
    //await load();
}
export async function search() {
    await load();
}
export async function clearRequest() {
    request.set({ referenceType: "", referenceValue: "" });
    response.set(null);
}
export async function load() {
    loading.set(true);
    try {
        let _req = get(request);
        let _resp = await TraceabilityService.getTraceability(_req);
        response.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
